import Vue from 'vue'
import VueRouter from 'vue-router'

// Headers & Footers
import MainHeader from '../components/MainHeader.vue'
import MainFooter from '../components/MainFooter.vue'


import Home from '../vues/Home.vue';
import ConditionsGeneralesServices from '../vues/ConditionsGeneralesServices.vue';

// Création d'entreprise
import Creation from '../vues/creation/Creation.vue'
import CreationHome from '../vues/creation/CreationHome.vue'
import CreationCommande from '../vues/creation/CreationCommande.vue'


// Domiciliation d'entreprise
import Domiciliation from '../vues/domiciliation/Domiciliation.vue'
import DomiciliationHome from '../vues/domiciliation/DomiciliationHome.vue'
import Address from '../vues/domiciliation/Address.vue'
import DomiciliationCommande from '../vues/domiciliation/DomiciliationCommande.vue'
import DomiciliationAddress from '../vues/domiciliation/DomiciliationAddress.vue'


Vue.use(VueRouter)


const routes = [{
        path: '/',
        components: {
            default: Home,
            header: MainHeader,
            footer: MainFooter
        }
    },
    {
        path: '/conditions-generales-services',
        component: ConditionsGeneralesServices
    },
    // Creation
    {
        path: '/creation',
        component: Creation,
        children: [{
                path: 'accueil',
                component: CreationHome
            },
            {
                path: 'commande',
                component: CreationCommande
            },
            {
                path: 'commande/:statut',
                component: CreationCommande
            }
        ]
    },
    // Domiciliation
    {
        path: '/domiciliation',
        component: Domiciliation,
        children: [{
                path: 'accueil',
                component: DomiciliationHome
            },
            {
                path: 'adresse/:addressId',
                name: 'address',
                component: Address
            },
            {
                path: 'commande',
                component: DomiciliationCommande,
                children: [{
                        path: 'adresse/:addressId',
                        component: DomiciliationAddress,
                        name: 'domiciliation_address'
                    },
                    {
                        path: 'adresse/:addressId/:statut',
                        component: DomiciliationAddress
                    }
                ]
            }
        ]
    }
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})


export default router